
export const POST_SCORECARD_TEMPLATE_CREATE_STARTED = 'POST_SCORECARD_TEMPLATE_CREATE_STARTED'
export const POST_SCORECARD_TEMPLATE_CREATE_FAILURE = 'POST_SCORECARD_TEMPLATE_CREATE_FAILURE'
export const POST_SCORECARD_TEMPLATE_CREATE_SUCCESS = 'POST_SCORECARD_TEMPLATE_CREATE_SUCCESS'


export const GET_SCORECARD_TEMPLATE_LIST_STARTED = 'GET_SCORECARD_TEMPLATE_LIST_STARTED'
export const GET_SCORECARD_TEMPLATE_LIST_FAILURE = 'GET_SCORECARD_TEMPLATE_LIST_FAILURE'
export const GET_SCORECARD_TEMPLATE_LIST_SUCCESS = 'GET_SCORECARD_TEMPLATE_LIST_SUCCESS'

export const PUT_SCORECARD_TEMPLATE_EDIT_STARTED = 'PUT_SCORECARD_TEMPLATE_EDIT_STARTED'
export const PUT_SCORECARD_TEMPLATE_EDIT_FAILURE = 'PUT_SCORECARD_TEMPLATE_EDIT_FAILURE'
export const PUT_SCORECARD_TEMPLATE_EDIT_SUCCESS = 'PUT_SCORECARD_TEMPLATE_EDIT_SUCCESS'

export const POST_IDEA_TEMPLATE_CREATE_STARTED = 'POST_IDEA_TEMPLATE_CREATE_STARTED'
export const POST_IDEA_TEMPLATE_CREATE_FAILURE = 'POST_IDEA_TEMPLATE_CREATE_FAILURE'
export const POST_IDEA_TEMPLATE_CREATE_SUCCESS = 'POST_IDEA_TEMPLATE_CREATE_SUCCESS'

export const GET_IDEA_TEMPLATE_LIST_STARTED = 'GET_IDEA_TEMPLATE_LIST_STARTED'
export const GET_IDEA_TEMPLATE_LIST_FAILURE = 'GET_IDEA_TEMPLATE_LIST_FAILURE'
export const GET_IDEA_TEMPLATE_LIST_SUCCESS = 'GET_IDEA_TEMPLATE_LIST_SUCCESS'

export const PUT_IDEA_TEMPLATE_EDIT_STARTED = 'PUT_IDEA_TEMPLATE_EDIT_STARTED'
export const PUT_IDEA_TEMPLATE_EDIT_FAILURE = 'PUT_IDEA_TEMPLATE_EDIT_FAILURE'
export const PUT_IDEA_TEMPLATE_EDIT_SUCCESS = 'PUT_IDEA_TEMPLATE_EDIT_SUCCESS'


export const GET_IDEA_TEMPLATE_EDIT_ID_STARTED = 'GET_IDEA_TEMPLATE_EDIT_ID_STARTED'
export const GET_IDEA_TEMPLATE_EDIT_ID_SUCCESS = 'GET_IDEA_TEMPLATE_EDIT_ID_SUCCESS'
export const GET_IDEA_TEMPLATE_EDIT_ID_FAILURE = 'GET_IDEA_TEMPLATE_EDIT_ID_FAILURE'

export const GET_SCORECARD_TEMPLATE_EDIT_ID_STARTED = 'GET_SCORECARD_TEMPLATE_EDIT_ID_STARTED'
export const GET_SCORECARD_TEMPLATE_EDIT_ID_SUCCESS = 'GET_SCORECARD_TEMPLATE_EDIT_ID_SUCCESS'
export const GET_SCORECARD_TEMPLATE_EDIT_ID_FAILURE = 'GET_SCORECARD_TEMPLATE_EDIT_ID_FAILURE'

export const CLONE_IDEA_TEMPLATE_ADD_STARTED = 'CLONE_IDEA_TEMPLATE_ADD_STARTED'
export const CLONE_IDEA_TEMPLATE_ADD_SUCCESS = 'CLONE_IDEA_TEMPLATE_ADD_SUCCESS'
export const CLONE_IDEA_TEMPLATE_ADD_FAILURE = 'CLONE_IDEA_TEMPLATE_ADD_FAILURE'

export const CLONE_SCORECARD_TEMPLATE_ADD_STARTED = 'CLONE_SCORECARD_TEMPLATE_ADD_STARTED'
export const CLONE_SCORECARD_TEMPLATE_ADD_SUCCESS = 'CLONE_SCORECARD_TEMPLATE_ADD_SUCCESS'
export const CLONE_SCORECARD_TEMPLATE_ADD_FAILURE = 'CLONE_SCORECARD_TEMPLATE_ADD_FAILURE'